import React from 'react'
import { Icon } from '@iconify/react'

import s from './CloseButton.module.css'

type SizeMap = {
  sm: string
  md: string
  lg: string
}

type Props = {
  size?: 'sm' | 'md' | 'lg'
  onClose?: (e: React.MouseEvent<HTMLElement, MouseEvent>) => void
}

const sizeMap: SizeMap = {
  sm: '14px',
  md: '16px',
  lg: '20px'
}

export const CloseButton = ({ size = 'md', onClose }: Props) => {
  const iconWidth = sizeMap[size]

  return (
    <button className={s.btn} onClick={onClose}>
      <Icon icon="lucide:x" width={iconWidth} />
    </button>
  )
}
